/* eslint-disable import/no-anonymous-default-export */
import { Outlet, RouteObject } from "react-router-dom";
import { lazy } from "react";

const EmployeeProfile = lazy(() => import("./EmployeeProfile"));

const EmployeeGroupOverview = lazy(
  () => import("./employeeGroups/employeeGroupOverview")
);

const NewEmployeeGroup = lazy(
  () => import("./employeeGroups/newEmployeeGroup/NewEmployeeGroup")
);

const ManageAccessRightsAndPermissions = lazy(() => import("."));

const AllCompanies = lazy(() => import("./companies/AllCompanies"));

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: "companies",
    element: <Outlet />,
    children: [
      { index: true, element: <AllCompanies /> },
      {
        path: "create-employee-group",
        element: <NewEmployeeGroup />,
      },
      {
        path: ":companyId/access-right",
        element: <Outlet />,
        children: [
          { index: true, element: <ManageAccessRightsAndPermissions /> },
          {
            path: "view-employee-group/:groupId",
            element: <EmployeeGroupOverview />,
          },
          {
            path: "view-employee-profile/:employeeId",
            element: <EmployeeProfile />,
          },
          {
            path: "add-employee-group",
            element: <NewEmployeeGroup />,
          },
        ],
      },
    ],
  },
] as RouteObject[];
